// extracted by mini-css-extract-plugin
export default {"paneBackLink":"paneBackLink---Q3YST"};